import { render, staticRenderFns } from "./XueYaAdd.vue?vue&type=template&id=a82020ec&scoped=true&"
import script from "./XueYaAdd.vue?vue&type=script&lang=js&"
export * from "./XueYaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82020ec",
  null
  
)

export default component.exports